// extracted by mini-css-extract-plugin
export default {"table":"ProductionTable_table__aFUN0","completed":"ProductionTable_completed__DQ9Vw","inProgress":"ProductionTable_inProgress__4sqZm","pending":"ProductionTable_pending__Vj9DL"};